import Model from './BaseModel';
import DerivedMarketTemplate from '@/Models/DerivedMarketTemplate.js';

export default class DerivedMarketGroup extends Model {
	resourceName() {
		return 'derived_market_groups';
	}

	fields() {
		return ['name', 'sport', 'market_types'];
	}

	relationships() {
		return {
			derived_market_templates: new DerivedMarketTemplate()
		};
	}

	getBySportId(sportId) {
		this.queryBuilder.include('derived_market_templates');
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sports/${sportId}/${this.resourceName()}${this.queryBuilder.getQuery()}`,
			method: 'GET'
		}).catch(() => {});
	}

	preparePayload(overrideData = {}) {
		const payload = {
			name: this.name,
			sport_id: this.sport.id,
			market_types: this.market_types,
			derived_market_templates: []
		};

		this.derived_market_templates.data.each((derived_market_template) => {
			payload.derived_market_templates.push(derived_market_template.id);
		});

		return Object.assign({}, payload, overrideData);
	}
}
